(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-lobster-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vs-lobster-popup')) {
    customElements.define('vs-lobster-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.storageKey = this.dataset.campaign;
        this.preview = this.dataset.preview === 'true';
        this.querySelectorAll('[data-popup-close]').forEach(button => {
          button.addEventListener('click', () => this.dialog.close(), { signal: this.controller.signal });
        });
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog) this.dialog.close();
        }, { signal: this.controller.signal });
        if (!this.preview) {
          try { if (sessionStorage.getItem(this.storageKey)) return; } catch {}
        }
        this.attempts = 0;
        this.timer = setTimeout(() => this.openWhenFree(), this.preview ? 200 : Number(this.dataset.delay) * 1000);
      }
      openWhenFree() {
        if (!this.isConnected || this.dialog.open) return;
        const otherDialog = document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]');
        const formsOpen = [...document.querySelectorAll('shopify-forms-embed')].some(host => {
          const root = host.shadowRoot?.querySelector('[data-form-root]');
          return root && root.dataset.currentStep !== 'tease' && root.getBoundingClientRect().height > 0;
        });
        const editing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '');
        if (document.hidden || otherDialog || formsOpen || editing) {
          if (++this.attempts < 15) this.timer = setTimeout(() => this.openWhenFree(), 1000);
          return;
        }
        this.dialog.showModal();
        if (!this.preview) {
          try { sessionStorage.setItem(this.storageKey, 'shown'); } catch {}
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
